import Vue from 'vue'
import Vuex from 'vuex'
import {
  login,
  getInfo,
  logout,
  loginMp,
  loginMpBind,
  switchWxCheck
} from '@/api/login'
import { getSysPosterConfigList } from '@/api/land'
import { sensorsLogin, sensorVisitorSet } from '@/util/sensors'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token'),
    channelNo: '',
    userList: [],
    cartData: [],
    leftIcon: false,
    user: null,
    active: 3,
    needChannelUrl: true,
    pageConfig: {}, // 后台配的页面配置，key: pageKey； value: pageValue
    activityModal: {
      visible: false,
      posterId: '',
      imageUrl: '',
      linkUrl: ''
    }
  },
  mutations: {
    changeCartData (state, data) {
      state.cartData = [...data, ...state.cartData]
    },
    set_token (state, token) {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_ACTIVE: (state, active) => {
      state.active = active
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_BUTTONS: (state, buttons) => {
      state.buttons = buttons
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_PAGE_CONFIG (state, pageConfig) {
      state.pageConfig = pageConfig
    },
    SET_ACTIVITY_MODAL_VISIBLE (state, visible) {
      state.activityModal.visible = visible
    }
  },
  actions: {
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then(response => {
            const result = response
            Vue.ls.set('ACCESS_TOKEN', result.token, 12 * 60 * 60 * 1000)
            commit('SET_USERID', result.userId)
            commit('set_token', result.token)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    loginMpBind ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginMpBind(userInfo)
          .then(response => {
            const result = response
            Vue.ls.set('ACCESS_TOKEN', result.token, 12 * 60 * 60 * 1000)
            commit('SET_USERID', result.userId)
            commit('set_token', result.token)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    switchWxCheck ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        switchWxCheck(obj)
          .then(response => {
            // console.log(response)
            // commit('SET_CODE', code)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    loginMp ({ commit }, code) {
      return new Promise((resolve, reject) => {
        loginMp(code)
          .then(response => {
            console.log(response)
            commit('SET_CODE', code)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(response => {
            if (response.code == 0) {
              const result = response.data || {}
              sensorsLogin(result.mercNo)
              sensorPeopleSet(result.buryingPoint)

              // console.log(result)
              commit('SET_ROLES', result.roleIds)
              commit('SET_BUTTONS', result.buttons)
              commit('SET_USERID', result.userId)
              commit('SET_INFO', result)
              console.log('result')
              console.log(result)
              commit('SET_NAME', { name: result.userName })
              commit('SET_AVATAR', result.avatar)
              resolve(response)
            } else {
              console.log(response)
              // Toast.error(response.msg)
            }
          })
          .catch(error => {
            console.log(error)
            // Toast.error(error.msg)
            reject(error)
          })
      })
    },
    // 登出
    Logout ({ commit, state }) {
      return new Promise(resolve => {
        logout(state.token)
          .then(() => {
            resolve()
          })
          .catch(() => {
            resolve()
          })
          .finally(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_INFO', {})
            Vue.ls.remove('cart_Data' + state.userId)
            Vue.ls.remove('ACCESS_TOKEN')
            // Vue.ls.remove('WX_OPENID')
          })
      })
    },
    getSysPosterConfigList ({ commit }, params) {
      return new Promise(async (resolve, reject) => {
        getSysPosterConfigList(params)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  },
  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js